/* tslint:disable */
/* eslint-disable */
/**
 * oeamtc-camping-api
 * ÖAMTC Camping API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jan.illetschko@3kraft.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export * from "./api";
export * from "./configuration";

